import { useQuery } from 'react-query';
import {
  CAMPAIGNS_KEY,
  getCampaignDuration,
} from 'api/services/mediaPlanning/campaigns';
import usePlanStore from 'store/planStore';
import prepareSelectData from 'pages/calculator/MediaPlanning/Plan/Countries/utils/prepareSelectData';
import { useTranslation } from 'react-i18next';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';

const useCampaignLength = (country: string) => {
  const { t } = useTranslation();

  const { generalInfoState, selectedCountryISOCode, countryForms } =
    usePlanStore((state) => ({
      generalInfoState: state.generalInfoState,
      selectedCountryISOCode: state.selectedCountryISOCode,
      countryForms: state.countryForms,
    }));

  const { showError } = useError();

  const {
    data: response,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [
      CAMPAIGNS_KEY,
      'campaign-duration',
      country,
      selectedCountryISOCode,
      countryForms[country]?.campaignScenario,
    ],
    queryFn: () =>
      getCampaignDuration(
        generalInfoState.division,
        selectedCountryISOCode as string,
        countryForms[country]?.campaignScenario
      ),
    enabled:
      !!selectedCountryISOCode &&
      !!generalInfoState.division &&
      !!countryForms[country]?.campaignScenario,
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
  });

  const numberOfCampaignWeeks = response?.data?.campaignLengths || [];
  const preparedData = prepareSelectData(
    numberOfCampaignWeeks,
    (week) => `${week} ${t('mediaPlanning.weeks')}`
  );

  return { data: preparedData, isFetching, refetch };
};

export default useCampaignLength;
